import angular from 'angular';

export default angular.module('video', ['ngDialog', 'ngSanitize'])
.directive('video', video)
.controller('videoCtrl', videoCtrl);

video.$inject = ['ngDialog'];

function video(ngDialog) {
	var directive = {
		restrict: 'A',
		scope: {},
		link: link
	};

	return directive;
	
	function link(scope, elem, attrs) {
		elem.on('click', (e) => {
			e.preventDefault();
			
			ngDialog.open({
				showClose: false,
				template: `${wp.template_directory_uri}/templates/video.html`,
				className: 'ngdialog-theme-custom',
				controller: 'videoCtrl',
				data: {
					video: attrs.videoUrl,
					type: attrs.videoType
				}
			});
		});
	}
}

videoCtrl.$inject = ['$scope', '$sce'];

function videoCtrl($scope, $sce) {
	$scope.trustSrc = function(src) {
		return $sce.trustAsResourceUrl(src);
	}
}



/** WEBPACK FOOTER **
 ** ./src/js/video/video.js
 **/